import { Role } from '@epilot/permissions/types'
import { Row } from '@tanstack/table-core'
import { useNavigate } from 'react-router-dom'

import { IUser } from '@/common'
import { JSONEditor } from '@/components/json-editor'
import { Badge } from '@/components/ui/badge'
import { DataTable } from '@/components/ui/data-table'
import { useJSONEditor } from '@/hooks/useJSONEditor'
import { useUserTable } from '@/hooks/useUserTable'
import { RoutePaths } from '@/routes/routes'

type UserListProps = {
  organizationId?: string
}

const UserList = ({ organizationId }: UserListProps) => {
  const {
    columns,
    data,
    isLoading,
    isReadyExport,
    onPaginationChange,
    isRolesLoading
  } = useUserTable(organizationId)

  const navigate = useNavigate()

  const jsonEditorProps = useJSONEditor()

  return (
    <>
      <DataTable
        columns={columns.map((column) => {
          if (column.id === 'roles') {
            return {
              ...column,
              cell: isRolesLoading
                ? ((
                    <div className="h-4 bg-muted rounded-lg animate-pulse" />
                  ) as any)
                : ({ row }: { row: Row<IUser> }) => {
                    const roles = data[row.index].roles ?? []

                    return (
                      <div className="flex overflow-y-scroll h-full py-3">
                        {(roles as Role[])?.map((role) => (
                          <Badge
                            className="hover:bg-secondary cursor-pointer mr-2 min-w-min whitespace-nowrap"
                            key={role.id + row.index}
                            onClick={(e) => {
                              e.stopPropagation()
                              jsonEditorProps.setOriginalData(role)
                              jsonEditorProps.setOpen(true)
                            }}
                            variant={'outline'}
                          >
                            {role.name}
                          </Badge>
                        ))}
                      </div>
                    )
                  }
            }
          }

          return column
        })}
        data={data}
        isLoading={isLoading}
        onPaginationChange={onPaginationChange}
        onRowClick={(row) => {
          navigate(
            `${RoutePaths.USERS}/${row.original.id}?orgId=${row.original.organization_id}`
          )
        }}
        tableConfigName="user"
        toolbarProps={{
          exportButtonProps: {
            loading: !isReadyExport
          }
        }}
      />
      <JSONEditor {...jsonEditorProps} />
    </>
  )
}

export default UserList
